// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__NypuO","image":"Profile_image__CVl0w","text-container":"Profile_text-container__-ymR0"};